export default __webpack_public_path__ + "static/media/dc-batman.ab9eadc3.jpg";